import { useMyLinesApiV1TelephonyNumbersMineGet } from '#/shared/api/generated/communication/theCargoCommunication'
import type { MyLine } from '#/shared/api/generated/communication/models'
import { TELEPHONY_NUMBERS_QUERY_OPTIONS } from '#/shared/lib/telephony'

export interface MyLinesResult {
  lines: MyLine[]
  isLoading: boolean
  /** The fetch has actually completed — distinguishes a loaded-empty list
   *  from a query that was deferred (`enabled: false`) and never ran. */
  loaded: boolean
}

/**
 * The current user's telephony lines (`GET /telephony/numbers/mine`). Each line
 * carries its own `outbound_sms` / `outbound_call` capability flags. Day-cached
 * and shared across every consumer (dialer, SMS pickers, readiness check).
 * Pass `enabled: false` to defer the fetch until the consuming UI is opened.
 */
export function useMyLines(options?: { enabled?: boolean }): MyLinesResult {
  const query = useMyLinesApiV1TelephonyNumbersMineGet({
    query: {
      ...TELEPHONY_NUMBERS_QUERY_OPTIONS,
      enabled: options?.enabled ?? true,
    },
  })
  return {
    lines: query.data?.data ?? [],
    isLoading: query.isLoading,
    loaded: query.data !== undefined,
  }
}
